import NovalueCheck from './NoValueCheck';

export default (value) => {
  if(NovalueCheck(value)) return NovalueCheck(value);

  if(value.indexOf('*/') >= 0) {
    value = value.split('*/');
  } else {
    value = value.split('/');
  }
  
  value[0] = +value[0];
  value[1] = +value[1];

  // ค่าปกติ: < 120/80 mmHg
  // ผิดปกติ: >= 140/90 mmHg

  if(value[0] < 120 && value[1] < 80) {
    return {
      title: 'ความดันปกติ',
      color: 'green',
      caption: 'ความดันอยู่ในเกณฑ์ปกติ',
      suggest: ''
    };
  } else if(value[0] < 140 && value[1] < 90) {
    return {
      title: 'ความดันปกติ',
      color: 'green',
      caption: 'ความดันอยู่ในเกณฑ์ปกติ (แนะนำให้ควบคุมอาหาร ลดเค็ม และออกกำลังกาย)',
      suggest: ''
    };
  } else {
    return {
      title: 'ความดันผิดปกติ',
      color: 'red',
      caption: 'ความดันสูงเกินกว่าปกติ',
      suggest: 'แนะนำให้ปรึกษาแพทย์เพื่อรักษา'
    };
  }
}